module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/th_4-83d968d50e4a71f3d44cffa320a07837.jpg";